<template>
    <div class="mb-10" style="min-height: 500px">
        <v-card flat>
            <v-card-text class="pa-0">
                <div class="pa-4 border-bottom">
                    <label class="darkgrey--text font-size-12">
                        Chat Room ID
                    </label>
                    <v-text-field
                        v-model="search"
                        outlined
                        hide-details
                        dense
                        placeholder="Masukan Chat Room ID"
                        :disabled="param_cr_id"
                        :readonly="param_cr_id"
                        @keyup.enter="onSearchMessage()"
                    />
                </div>

                <consul-chat-detail v-if="detail.status" :detail="detail" />

                <div v-if="detail.status && !loading" class="pa-4">
                    <!------Date & Consul Status--------->
                    <v-card flat color="#f0f3f9">
                        <v-card-text
                            class="py-2 text-center font-weight-500 greynew--text d-flex align-center justify-center"
                        >
                            <span>
                                {{
                                    $moment(detail.date).format("DD MMMM YYYY")
                                }}
                            </span>

                            <v-chip
                                v-if="detail.status"
                                :color="getStatusColor(detail.status)"
                                small
                                dark
                                class="ml-2"
                            >
                                {{ detail.status }}
                            </v-chip>
                        </v-card-text>
                    </v-card>
                    <!------Date & Consul Status--------->

                    <section class="mt-5 relative">
                        <div v-if="checkingUserRole()" class="backdrop-blur">
                            <div class="text-center blacknew--text mt-10">
                                <v-icon color="#f5ac2a" size="lg"
                                    >mdi-lock</v-icon
                                >
                                <div class="font-weight-600 font-size-16 mt-2">
                                    Restricted Access
                                </div>
                                <div class="black60--text">
                                    Hanya dapat diakses oleh Head of Psychology.
                                </div>
                            </div>
                        </div>

                        <div v-for="(message, index) in messages" :key="index">
                            <!------Chat Teacher--------->
                            <div
                                v-if="message.user_id === detail.teacher_id"
                                class="d-flex gap-10 align-center mb-4"
                            >
                                <div class="font-size-12">
                                    {{ detail.teacher_name }}
                                </div>

                                <div
                                    v-if="message.type === 1"
                                    class="chat-teacher"
                                >
                                    {{ message.message }}
                                </div>

                                <div v-if="message.type === 2">
                                    <v-img
                                        :src="message.message"
                                        class="chat-teacher-img"
                                    />
                                </div>

                                <div v-if="message.type === 3">
                                    <a
                                        :href="message.message"
                                        :filename="message.fileName"
                                        target="_blank"
                                    >
                                        <v-list-item
                                            class="px-1 align-center gap-10 font-size-14"
                                        >
                                            <div>
                                                <v-icon>mdi-file</v-icon>
                                            </div>
                                            <div>
                                                {{ message.fileName }}
                                            </div>
                                        </v-list-item>
                                    </a>
                                </div>

                                <div v-if="message.type === 4">
                                    <plyr
                                        ref="plyr"
                                        :controls="[
                                            'play',
                                            'progress',
                                            'current-time',
                                            'duration',
                                        ]"
                                    >
                                        <audio controls>
                                            <source
                                                :src="message.message"
                                                type="audio/mp3"
                                            />
                                        </audio>
                                    </plyr>
                                </div>

                                <div v-if="message.type === 5">
                                    <plyr
                                        ref="plyr"
                                        :controls="[
                                            'play',
                                            'progress',
                                            'current-time',
                                            'duration',
                                        ]"
                                    >
                                        <video controls>
                                            <source
                                                :src="message.message"
                                                type="video/mp4"
                                            />
                                        </video>
                                    </plyr>
                                </div>

                                <div class="font-size-12" align="right">
                                    <v-icon color="#00cf3f" small>
                                        mdi-check-all
                                    </v-icon>
                                    <div style="margin-top: -3px">
                                        {{ getTimeMessage(message.created_at) }}
                                    </div>
                                </div>
                            </div>
                            <!------End Chat Teacher--------->

                            <!------Chat Student--------->
                            <div
                                v-if="message.user_id === detail.student_id"
                                class="d-flex gap-10 justify-end align-center mb-4"
                            >
                                <div class="font-size-12" align="right">
                                    <v-icon color="#00cf3f" small>
                                        mdi-check-all
                                    </v-icon>
                                    <div style="margin-top: -3px">
                                        {{ getTimeMessage(message.created_at) }}
                                    </div>
                                </div>

                                <div
                                    v-if="message.type === 1"
                                    class="chat-student"
                                >
                                    {{ message.message }}
                                </div>

                                <div v-if="message.type === 2">
                                    <v-img
                                        :src="message.message"
                                        class="chat-student-img"
                                    />
                                </div>

                                <div v-if="message.type === 3">
                                    <a
                                        :href="message.message"
                                        :filename="message.fileName"
                                        target="_blank"
                                    >
                                        <v-list-item
                                            class="px-1 align-center gap-10 font-size-14"
                                        >
                                            <div>
                                                <v-icon>mdi-file</v-icon>
                                            </div>
                                            <div>
                                                {{ message.fileName }}
                                            </div>
                                        </v-list-item>
                                    </a>
                                </div>

                                <div v-if="message.type === 4">
                                    <plyr
                                        ref="plyr"
                                        :controls="[
                                            'play',
                                            'progress',
                                            'current-time',
                                            'duration',
                                        ]"
                                    >
                                        <audio controls>
                                            <source
                                                :src="message.message"
                                                type="audio/mp3"
                                            />
                                        </audio>
                                    </plyr>
                                </div>

                                <div v-if="message.type === 5">
                                    <plyr
                                        ref="plyr"
                                        :controls="[
                                            'play',
                                            'progress',
                                            'current-time',
                                            'duration',
                                        ]"
                                    >
                                        <video controls>
                                            <source
                                                :src="message.message"
                                                type="video/mp4"
                                            />
                                        </video>
                                    </plyr>
                                </div>
                            </div>
                            <!------End Chat Student--------->
                        </div>
                    </section>
                </div>

                <div v-if="!detail.status && !loading" class="pa-3">
                    <v-card outlined>
                        <v-card-text>
                            <div class="text-center">
                                {{
                                    search_status
                                        ? "Data chat konsul tidak ditemukan"
                                        : "Masukan cr_id untuk memulai pencarian data chat konsul"
                                }}
                            </div>
                        </v-card-text>
                    </v-card>
                </div>

                <div v-if="loading" class="text-center pa-10">
                    <v-progress-circular
                        indeterminate
                        color="primary"
                    ></v-progress-circular>
                </div>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { mapState } from "vuex";
import ConsulChatDetail from "./ConsulChatDetail.vue";
import firebase from "firebase";
import axios from "axios";

export default {
    name: "consultant-chat-list",
    components: {
        ConsulChatDetail,
    },
    data() {
        return {
            search: null,
            loading: false,
            data: [],
            messages: [],
            cr_id: null,
            detail: {},
            search_status: false,
        };
    },

    computed: {
        ...mapState(["auth"]),

        param_cr_id() {
            return this.$route.query.cr_id;
        },

        user_email() {
            return this.$ls.get("profiles").email;
        },
    },

    mounted() {
        if (this.param_cr_id) {
            this.cr_id = this.param_cr_id;
            this.search = this.param_cr_id;

            this.onSearchMessage();
        }
    },

    methods: {
        async onSearchMessage() {
            this.cr_id = this.search;
            this.loading = true;
            this.search_status = false;
            await this.delay(700);
            this.getDetailKonsul();
        },

        getDetailKonsul() {
            const url = `${process.env.API_BASE_URL}konsul/admin/${this.cr_id}/konsul`;
            const authToken = JSON.parse(localStorage.getItem("token")).value;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            const self = this;
            self.loading = true;

            axios
                .get(url, options)
                .then(function (response) {
                    self.detail = response.data;
                    self.getChatList();
                })
                .catch(() => {
                    self.detail = {};
                    self.messages = [];
                })
                .finally(() => {
                    self.loading = false;
                    self.search_status = true;
                });
        },

        getChatList() {
            this.loading = true;

            try {
                var docRef = firebase
                    .firestore()
                    .collection("chat_rooms")
                    .doc(`CHAT_${this.cr_id}`)
                    .collection("message")
                    .orderBy("created_at");
                docRef.onSnapshot((doc) => {
                    var allMessages = [];
                    doc.forEach((doc) => {
                        allMessages.push(doc.data());
                    });
                    this.messages = allMessages;
                });
            } catch (error) {
                console.log("Fetch Messages Error :", error);
            } finally {
                this.loading = false;
            }
        },

        getTimeMessage(date) {
            var hours = new Date(date).getHours();
            var minutes = new Date(date).getMinutes();

            hours = hours < 10 ? `0${hours}` : hours;
            minutes = minutes < 10 ? `0${minutes}` : minutes;
            var time = `${hours}:${minutes}`;

            return time;
        },

        delay(ms) {
            return new Promise((resolve) => setTimeout(resolve, ms));
        },

        getStatusColor(status) {
            switch (status) {
                case "finished":
                    return "#2fca9e";
                case "started":
                    return "blew";
                case "canceled":
                    return "red";
                case "timeout":
                    return "orange";
                default:
                    return "grey";
            }
        },

        checkingUserRole() {
            const list_mapel = ["Pengembangan Diri", "Konsul Prodi PTN"];
            const list_email_user = ["psikolog"];

            if (
                list_mapel.some((keyword) =>
                    this.detail.subject_name.includes(keyword)
                ) &&
                list_email_user.some(
                    (keyword) => !this.user_email.includes(keyword)
                )
            ) {
                return true;
            }
        },
    },
};
</script>

<style>
.chat-teacher {
    background-color: #e1f4fc;
    color: #2d3643;
    font-size: 14px;
    border-radius: 0px 15px 20px 15px;
    padding: 12px;
    max-width: 400px;
}

.chat-student {
    background-color: #0e97d6;
    color: #fff;
    font-size: 14px;
    border-radius: 15px 15px 0px 15px;
    padding: 12px;
    max-width: 400px;
}

.chat-teacher-img {
    border-radius: 15px;
    max-width: 400px;
}

.chat-student-img {
    border-radius: 15px;
    max-width: 400px;
}

.backdrop-blur {
    padding-top: 5%;
    height: 100%;
    position: absolute;
    display: flex;
    justify-content: center;
    width: 100%;
    z-index: 2;
    position: absolute;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.25);
    -webkit-backdrop-filter: blur(8px);
    backdrop-filter: blur(8px);
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// ConsulChatList.vue?341561cc